import "@suite/panels/theme/tokens.css";
import "@suite/panels/primitives/nativeTooltipBridge"; // retires the browser-default tooltip suite-wide
import "@suite/documents/theme/tokens.css";
import "@suite/documents/theme/workspace.css";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Providers } from '@/components/providers';
import { TourProvider } from '@suite/tour';
import { App } from './App';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* First-run tour provider (docs/product/onboarding-tour): inert until
          the engine's gate starts it; flag lives in localStorage. */}
      <TourProvider>
        <Providers>
          <App />
        </Providers>
      </TourProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Mobile-web parity: the installable shell (PWA manifest + offline fallback).
// Registration is deliberately quiet — an insecure origin (plain LAN http) and
// the Vite dev server (session-scoped HMR tokens must never hit the shell cache)
// simply skip it, which is the supported path for the desktop suite.
if ("serviceWorker" in navigator && window.isSecureContext && !import.meta.env.DEV) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
